import cx from 'classnames';
import {last, split, toLower} from 'lodash';
import {useMemo} from 'react';

import {Icon} from 'components';

import {FileInfo} from '../../types';

type Props = {
    name?: string;
    path: string;
    selected: boolean;
    imageOnly?: boolean;
    className?: string;
    imageSize?: 'md' | 'lg';
    onRemove: (file: FileInfo) => void;
    onSelect?: (file: FileInfo) => void;
};

const IMG_PREVIEW_EXTENSIONS = ['jpg', 'jpeg', 'png'];

export const FilePreview: React.FC<Props> = ({
    name, path, imageSize = 'md', selected, className = '', imageOnly, onRemove, onSelect
}: Props) => {
    const extension = useMemo(() => toLower(last(split(name, '.'))), [name]);

    return (
        <div className={cx('tw-inline-flex tw-flex-col tw-items-center', className)}>
            <div className={cx({
                'tw-w-32': imageSize === 'lg',
                'tw-w-16': imageSize === 'md'
            })}
            >
                <div className='tw-relative tw-w-full'>
                    <div
                        className={cx('tw-flex-center tw-cursor-pointer tw-overflow-hidden', {
                            'tw-h-32': imageSize === 'lg',
                            'tw-h-16': imageSize === 'md'
                        })}
                        onClick={() => onSelect?.({name, path})}
                    >
                        {IMG_PREVIEW_EXTENSIONS.includes(extension) ?
                            <img
                                className='max-w-full max-h-full tw-bg-transparent tw-overflow-hidden'
                                src={`${path}?w=64`}
                                alt={name || path}
                            /> :
                            <div className='tw-flex-center tw-h-full tw-w-full tw-bg-default'>{extension}</div>}
                        {selected && <div className='tw-absolute tw-inset-0 tw-border-4 tw-border-primary-light' />}
                    </div>
                    <div
                        className='tw-absolute tw--right-1 tw--bottom-1 tw-rounded-full tw-bg-light tw-z-1'
                        onClick={() => onRemove({name, path})}
                    >
                        <Icon name='x-circle' color='alert' size='sm' button />
                    </div>
                </div>

                {!imageOnly &&
                    <div
                        className='tw-mt-2 tw-text-center tw-text-sm tw-cursor-pointer tw-break-all tw-text-default'
                        onClick={() => onSelect?.({name, path})}
                    >
                        {name}
                    </div>}
            </div>
        </div>
    );
};